import React from 'react'
import PropTypes from 'prop-types'
import { t, Trans } from '@lingui/macro'
import { useMediaQuery } from 'react-responsive'
import BackButton from '../../../components/BackButton'
import AppPreview from '../../../components/AppPreview'
import ChevronDownIcon from '../../../components/common/icons/ChevronDownIcon'

import './HeaderSection.scss'

const APP_NAME = 'Application Name'
const APP_TITLE = t`Setting up your Yoti to use with ${APP_NAME}`
const APP_DESCRIPTION = t`Creating a Yoti is secure, safe, seamless and takes minutes.`
const BACK_BUTTON_TEXT = t`Back to website`


const HeaderSection = ({
  name,
  logoUrl,
  verified,
  referringWebsite
}) => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })

  const goBack = () => {
    if (referringWebsite) window.location.href = referringWebsite
  }

  return (
    <div className="header-section">
      {
        referringWebsite
        && (
          <BackButton fullWidth={isMobile} goBack={goBack}>
            <Trans id={BACK_BUTTON_TEXT} />
          </BackButton>
        )
      }
      <div className="header-section--align-center">
        <div>
          <div>
            <div className="header-section__container">
              <AppPreview appName={name} verified={verified} appLogoUrl={logoUrl} />
              <h1 className="header-section__container__title">
                <Trans id={APP_TITLE} values={{ APP_NAME: name }} />
              </h1>
              <div className="header-section__container__description">
                <Trans id={APP_DESCRIPTION} />
              </div>
            </div>
          </div>
          { isMobile && <ChevronDownIcon /> }
        </div>
      </div>
    </div>
  )
}


HeaderSection.propTypes = {
  name: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  verified: PropTypes.bool.isRequired,
  referringWebsite: PropTypes.string.isRequired
}

export default HeaderSection
